import axios from "axios";
import { IBookingRequestRequest } from "./Booking.types";

export default class BookingApi {
    static async createBooking(values:IBookingRequestRequest) {
        try {
            await axios.post(`/BookingRequest/Create`, values);
            return true;
        } catch (e: any) {
            console.error('Could not create booking: ', e.response.data);
            return {errors: e.response.data};
        }
    }
}